import NotFoundPage from "./NotfoundPage";

export default NotFoundPage;
